import { Box, Card, CircularProgress, Grid, Icon, IconButton, InputLabel, Skeleton, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCompanySelect from "components/MDCompanySelect";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import { useMaterialUIController } from "context";
import { Form, Formik, useFormikContext } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import PropTypes from "prop-types";
import { memo, useEffect, useState } from "react";
import { errorAlert, successAlert, formatarTelefone, maskPhoneWithDdd } from "utils/Functions";
import { get, postNoResponse } from "utils/WebService";
import * as Yup from "yup";
import { menus } from "utils/Enums";

const UserCreateEdit = ({
    userId,
    closeCreateEdit,
    refreshTable
}) => {

    const {
        nome,
        email,
        observacao,
        ramal,
        dataAdmissao,
        dataDesligamento,
        perfils,
        empresa,
        telefonePessoal,
        telefoneComercial } = configForm.formField

    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [profileOptions, setProfileOptions] = useState([]);
    const [isLoadingProfileOptions, setIsLoadingProfileOptions] = useState(true);
    const [grupoOptions, setGrupoOptions] = useState([]);

    useEffect(() => {

        get("/profiles/list-all")
            .then(({ list }) => {
                setProfileOptions(list);
                setIsLoadingProfileOptions(false);
            }).catch(() => {
                setProfileOptions([]);
                setIsLoadingProfileOptions(false);
            });
    }, []);

    const handleSumit = (values, actions) => {
        const usuario = {
            id: values.id,
            ativo: values.ativo,
            bloqueado: values.bloqueado,
            observacao: values.observacao,
            email: values.email,
            nome: values.nome,
            perfils: values.perfils,
            clientes: values.empresa,
            usaApp2FA: values.usaApp2FA,
            usaEmail2FA: values.usaEmail2FA,
            ramal: values.ramal,
            dataAdmissao: values.dataAdmissao,
            dataDesligamento: values.dataDesligamento
        }
        
        if (values.telefonePessoal) {
            const digits = values.telefonePessoal.replace(/\D/g, "");
            if (digits.length >= 10) {
                usuario.dddPessoal = digits.substring(0, 2);
                usuario.telefonePessoal = digits.substring(2);
            } else {
                usuario.telefonePessoal = digits;
            }
        } else {
            usuario.dddPessoal = null;
            usuario.telefonePessoal = null;
        }
        if (values.telefoneComercial) {
            const digits = values.telefoneComercial.replace(/\D/g, "");
            if (digits.length >= 10) {
                usuario.dddComercial = digits.substring(0, 2);
                usuario.telefoneComercial = digits.substring(2);
            } else {
                usuario.telefoneComercial = digits;
            }
        } else {
            usuario.dddComercial = null;
            usuario.telefoneComercial = null;
        }
        postNoResponse("/users/save", usuario)
            .then(() => {
                successAlert(!userId ? "Usuário criado com sucesso!" : "Alterações salvas!", handleSucess());
            }).catch((error) => {
                if (error && error.status === 409) {
                    errorAlert("Este e-mail já está cadastrado!");
                } else {
                    errorAlert(!userId ? "Erro ao criar usuário!" : 'Erro ao salvar alterações.');
                }
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    }

    function handleSucess() {
        closeCreateEdit()
        refreshTable()
    }


    return (
        <Card id="user-info">
            <MDBox display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{userId ? "Editar" : "Adicionar"} Usuário</MDTypography>
            </MDBox>
            <Formik
                initialValues={{
                    id: null,
                    nome: '',
                    email: '',
                    observacao: '',
                    ativo: false,
                    bloqueado: false,
                    perfils: null,
                    empresa: null,
                    menusAllowed: [],
                    usaApp2FA: false,
                    usaEmail2FA: false,
                    ramal: '',
                    telefonePessoal: '',
                    telefoneComercial: '',
                    dataAdmissao: '',
                    dataDesligamento: ''
                }}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(true);
                    handleSumit(values, actions);
                }}>
                {({ values, errors, touched, isSubmitting, setFieldValue }) => {

                    const handleCompanyChange = (selectedOption) => {
                        setFieldValue("empresa", selectedOption)
                    };

                    return (
                        <Form id={configForm.formId} autoComplete="off">
                            <FetchAndSetData
                                userId={userId}
                                setIsLoadingInfo={setIsLoadingInfo}
                                closeCreateEdit={closeCreateEdit} />

                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={nome.type}
                                            label={nome.label}
                                            name={nome.name}
                                            value={values.nome}
                                            placeholder={nome.placeholder}
                                            error={errors.nome?.length > 0 && touched.nome}
                                            inputProps={{ sx: { height: '30px' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={email.type}
                                            label={email.label}
                                            name={email.name}
                                            value={values.email}
                                            placeholder={email.placeholder}
                                            error={errors.email?.length > 0 && touched.email}
                                            inputProps={{ sx: { height: '30px' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={ramal.type}
                                            label={ramal.label}
                                            name={ramal.name}
                                            value={values.ramal || ""}
                                            placeholder={ramal.placeholder}
                                            inputProps={{ sx: { height: '30px' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={observacao.type}
                                            label={observacao.label}
                                            name={observacao.name}
                                            value={values.observacao || ""}
                                            placeholder={observacao.placeholder}
                                            inputProps={{ sx: { height: '30px' } }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={telefonePessoal.type}
                                            label={telefonePessoal.label}
                                            name={telefonePessoal.name}
                                            value={values.telefonePessoal || ""}
                                            onChange={(e) => setFieldValue('telefonePessoal', maskPhoneWithDdd(e.target.value))}
                                            placeholder={telefonePessoal.placeholder}
                                            error={errors.telefonePessoal?.length > 0 && touched.telefonePessoal}
                                            inputProps={{ sx: { height: '30px' } }}
                                        />
                                        {errors.telefonePessoal && touched.telefonePessoal && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.telefonePessoal}
                                            </MDTypography>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={telefoneComercial.type}
                                            label={telefoneComercial.label}
                                            name={telefoneComercial.name}
                                            value={values.telefoneComercial || ""}
                                            onChange={(e) => setFieldValue('telefoneComercial', maskPhoneWithDdd(e.target.value))}
                                            placeholder={telefoneComercial.placeholder}
                                            error={errors.telefoneComercial?.length > 0 && touched.telefoneComercial}
                                            inputProps={{ sx: { height: '30px' } }}
                                        />
                                        {errors.telefoneComercial && touched.telefoneComercial && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.telefoneComercial}
                                            </MDTypography>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                                            {dataAdmissao.label}
                                        </InputLabel>
                                        {isLoadingInfo ? <Skeleton height={50} /> :
                                            <MDTextFieldCalendar
                                                size="small"
                                                type="date"
                                                value={values.dataAdmissao || ""}
                                                fullWidth
                                                onChange={(event) => setFieldValue("dataAdmissao", event.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                darkMode={darkMode}
                                            />
                                        }
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                                            {dataDesligamento.label}
                                        </InputLabel>
                                        {isLoadingInfo ? <Skeleton height={50} /> :
                                            <MDTextFieldCalendar
                                                size="small"
                                                type="date"
                                                value={values.dataDesligamento || ""}
                                                fullWidth
                                                onChange={(event) => setFieldValue("dataDesligamento", event.target.value)}
                                                InputLabelProps={{ shrink: true }}
                                                darkMode={darkMode}
                                            />
                                        }
                                    </Grid>
                                    <Grid item xs={12} sm={9}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                                            {perfils.label}
                                        </InputLabel>
                                        <MDSelect
                                            isLoading={isLoadingInfo || isLoadingProfileOptions}
                                            isMulti={false}
                                            getOptionValue={option => option.id}
                                            getOptionLabel={option => option.nome}
                                            options={profileOptions}
                                            name="perfils"
                                            placeholder={perfils.placeholder}
                                            value={values.perfils && values.perfils.length > 0 ? values.perfils[0] : null}
                                            onChange={(selectedOption) => setFieldValue('perfils', selectedOption ? [selectedOption] : [])}
                                        />
                                        {errors.perfils && touched.perfils && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.perfils}
                                            </MDTypography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '4px' }}>
                                        {isLoadingInfo ? <Skeleton width={"80%"} sx={{ mt: 2 }} /> :
                                            <MDBox display="flex" alignItems="center" gap={2} lineHeight={1}>
                                                <MDBox display="flex" alignItems="center">
                                                    <MDTypography variant="button" sx={{ fontSize: '11px', marginRight: 0.5 }}>
                                                        Ativo
                                                    </MDTypography>
                                                    <Switch color="info" checked={values.ativo || false} onChange={(event) => setFieldValue('ativo', event.target.checked)} />
                                                </MDBox>
                                                <MDBox display="flex" alignItems="center">
                                                    <MDTypography variant="button" sx={{ fontSize: '11px', marginRight: 0.5 }}>
                                                        Bloq.
                                                    </MDTypography>
                                                    <Switch color="info" checked={values.bloqueado || false} onChange={(event) => setFieldValue('bloqueado', event.target.checked)} />
                                                </MDBox>
                                                <MDBox display="flex" alignItems="center">
                                                    <MDTypography variant="button" sx={{ fontSize: '11px', marginRight: 0.5 }}>
                                                        2FA (App)
                                                    </MDTypography>
                                                    <Switch color="info" checked={values.usaApp2FA || false} onChange={(event) => setFieldValue('usaApp2FA', event.target.checked)} />
                                                </MDBox>
                                                <MDBox display="flex" alignItems="center">
                                                    <MDTypography variant="button" sx={{ fontSize: '11px', marginRight: 0.5 }}>
                                                        2FA (E-mail)
                                                    </MDTypography>
                                                    <Switch color="info" checked={values.usaEmail2FA || false} onChange={(event) => setFieldValue('usaEmail2FA', event.target.checked)} />
                                                </MDBox>
                                            </MDBox>
                                        }
                                    </Grid>

                                    {!values.perfils?.some(profile => profile.nome === "Administrador") &&
                                        <Grid item xs={12} sm={12}>
                                            <MDCompanySelect
                                                label={empresa.label}
                                                value={values.empresa}
                                                handleChange={handleCompanyChange}
                                                placeholder={empresa.placeholder}
                                                isMulti={true}
                                                name="client-multi-select"
                                            />
                                            {errors.empresa && touched.empresa && (
                                                <MDTypography variant="caption" color="error">
                                                    {errors.empresa}
                                                </MDTypography>
                                            )}
                                        </Grid>
                                    }
                                </Grid>
                            </MDBox>

                            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                <MDButton
                                    disabled={isLoadingInfo
                                        || isLoadingProfileOptions}
                                    size="large"
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    type="submit"
                                    endIcon={isSubmitting ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                                    {!isSubmitting && (userId ? "Salvar" : "Adicionar")}
                                </MDButton>
                            </Box>
                        </Form>)
                }}
            </Formik>
        </Card>
    );
};

export const configForm = {
    formId: "configuration-form",
    formField: {
        perfils: {
            name: "perfils",
            label: "Perfis",
            placeholder: "Selecione o perfil",
            errorMsg: "Campo Obrigatório.",
        },
        empresa: {
            name: "empresa",
            label: "Empresa",
            placeholder: "Selecione a empresa",
            errorMsg: "Campo Obrigatório.",
        },
        menusAllowed: {
            name: "menusAllowed",
            label: "Menus Permitidos",
            placeholder: "Selecione os menus...",
        },
        nome: {
            name: "nome",
            label: "Nome",
            type: "text",
            placeholder: "Informe o nome...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        email: {
            name: "email",
            label: "E-mail",
            type: "text",
            placeholder: "Informe o e-mail...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        observacao: {
            name: "observacao",
            label: "Observação",
            type: "text",
            placeholder: "Informe alguma observação...",
        },
        ramal: {
            name: "ramal",
            label: "Ramal (Telefonia)",
            type: "text",
            placeholder: "Ex: sup9001",
        },
        telefonePessoal: {
            name: "telefonePessoal",
            label: "Telefone Pessoal",
            type: "text",
            placeholder: "Ex: 11 999999999",
        },
        telefoneComercial: {
            name: "telefoneComercial",
            label: "Telefone Comercial",
            type: "text",
            placeholder: "Ex: 11 999999999",
        },
        dataAdmissao: {
            name: "dataAdmissao",
            label: "Data de Admissão",
        },
        dataDesligamento: {
            name: "dataDesligamento",
            label: "Data de Desligamento",
        }
    }
}

const FetchAndSetData = ({ userId, setIsLoadingInfo, closeCreateEdit }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        if (userId) {
            setIsLoadingInfo(true);
            get(`/users/by-id/${userId}`)
                .then(data => {
                    const { id, nome, email, ativo, bloqueado, perfils, observacao, clientes, usaApp2FA, usaEmail2FA, ramal, dataAdmissao, dataDesligamento, dddPessoal, telefonePessoal, dddComercial, telefoneComercial } = data;
                    setFieldValue('perfils', perfils);
                    setFieldValue('ativo', ativo);
                    setFieldValue('nome', nome);
                    setFieldValue('email', email);
                    setFieldValue('id', id);
                    setFieldValue('bloqueado', bloqueado);
                    setFieldValue('observacao', observacao);
                    setFieldValue('ramal', ramal);
                    setFieldValue('telefonePessoal', formatarTelefone(dddPessoal, telefonePessoal));
                    setFieldValue('telefoneComercial', formatarTelefone(dddComercial, telefoneComercial));
                    setFieldValue('dataAdmissao', dataAdmissao ? dataAdmissao.substring(0, 10) : "");
                    setFieldValue('dataDesligamento', dataDesligamento ? dataDesligamento.substring(0, 10) : "");
                    setFieldValue('empresa', clientes);
                    setFieldValue('usaApp2FA', usaApp2FA);
                    setFieldValue('usaEmail2FA', usaEmail2FA);
                    setIsLoadingInfo(false);
                }).catch(() => errorAlert("Usuário não encontrado!", closeCreateEdit));
        }
    }, [userId]);

    return null;
};

const {
    formField: {
        nome,
        perfils,
        empresa,
        email
    },
} = configForm;

export const validationSchema = Yup.object().shape({
    [perfils.name]: Yup.array()
        .required(perfils.errorMsg),
    [empresa.name]: Yup.array().nullable(),
    [nome.name]: Yup.string()
        .required(nome.errorMsg),
    [email.name]: Yup.string()
        .required(email.errorMsg),
    telefonePessoal: Yup.string().test("is-valid-phone", "Incompleto (min. 10 dítigos com DDD)", value => {
        if (!value) return true;
        const digits = value.replace(/\D/g, "");
        return digits.length === 10 || digits.length === 11;
    }),
    telefoneComercial: Yup.string().test("is-valid-phone", "Incompleto (min. 10 dítigos com DDD)", value => {
        if (!value) return true;
        const digits = value.replace(/\D/g, "");
        return digits.length === 10 || digits.length === 11;
    }),
});


UserCreateEdit.propTypes = {
    userId: PropTypes.any,
    closeCreateEdit: PropTypes.func.isRequired,
};

export default memo(UserCreateEdit);

